import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RELEASES = {
  band2: {
    date: new Date("2026-09-14T00:00:00+02:00"),
    stamp: "Akte Nº 002 · Versiegelt",
    title: "Band II wird geöffnet in",
    note: "Freigabe am 14.09.2026, zuerst auf TikTok. Bundle-Käufer erhalten Band II automatisch per E-Mail, bevor die Akte offiziell geöffnet wird.",
  },
  band3: {
    date: new Date("2026-12-01T00:00:00+01:00"),
    stamp: "Akte Nº 003 · Versiegelt",
    title: "Band III wird geöffnet in",
    note: "Freigabe am 01.12.2026, zuerst auf TikTok. Bundle-Käufer erhalten Band III automatisch per E-Mail, bevor die Akte offiziell geöffnet wird.",
  },
};

const pad = (n) => String(n).padStart(2, "0");

const Unit = ({ value, label, testId }) => (
  <div className="glass rounded-xl px-2 py-4 sm:px-8 sm:py-7 text-center min-w-[70px] sm:min-w-[110px] flex-1 sm:flex-none max-w-[86px]">
    <p className="font-cinzel text-2xl sm:text-5xl font-bold text-white tabular-nums" data-testid={testId}>
      {pad(value)}
    </p>
    <p className="font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.2em] sm:tracking-[0.3em] text-slate-500 mt-2">{label}</p>
  </div>
);

export const Countdown = () => {
  const [flags, setFlags] = useState({ band2: false, band3: false });
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    axios
      .get(`${API}/books`)
      .then((res) =>
        setFlags({ band2: !!res.data?.band2_released, band3: !!res.data?.band3_released })
      )
      .catch(() => {});
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const release = flags.band2 ? (flags.band3 ? null : RELEASES.band3) : RELEASES.band2;
  const diff = release ? Math.max(0, release.date.getTime() - now) : 0;
  const opening = release && diff === 0;
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor(diff / 3600000) % 24;
  const minutes = Math.floor(diff / 60000) % 60;
  const seconds = Math.floor(diff / 1000) % 60;

  return (
    <section id="band2-countdown" className="relative py-20 lg:py-28" data-testid="countdown-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          {!release ? (
            <>
              <span className="stamp text-xs" data-testid="countdown-stamp">
                Trilogie · Vollständig
              </span>
              <h2 className="font-cinzel text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mt-8" data-testid="countdown-title">
                Alle Akten sind geöffnet
              </h2>
              <p className="mt-8 text-sm sm:text-base text-slate-400 max-w-md mx-auto">
                Die komplette Trilogie ist erhältlich. Die Akte ist geschlossen, dein Blick ist geschärft.
              </p>
            </>
          ) : (
            <>
              <span className="stamp text-xs" data-testid="countdown-stamp">
                {release.stamp}
              </span>
              <h2 className="font-cinzel text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mt-8" data-testid="countdown-title">
                {opening ? "Die Akte wird gerade geöffnet" : release.title}
              </h2>
              {!opening && (
                <div className="mt-10 flex justify-center gap-2 sm:gap-5 flex-nowrap" data-testid="countdown-timer">
                  <Unit value={days} label="Tage" testId="countdown-days" />
                  <Unit value={hours} label="Stunden" testId="countdown-hours" />
                  <Unit value={minutes} label="Minuten" testId="countdown-minutes" />
                  <Unit value={seconds} label="Sekunden" testId="countdown-seconds" />
                </div>
              )}
              <p className="mt-8 text-sm sm:text-base text-slate-400 max-w-md mx-auto">
                {release.note}
              </p>
            </>
          )}
        </motion.div>
      </div>
    </section>
  );
};
